import {
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { NegotiationDetailModalTemplate as template } from './negotiation-detail-modal.template';
import { NegotiationDetailModalStyles as styles } from './negotiation-detail-modal.styles';
import { INegotiationService } from '../../../services';
import { IRfqInsert } from '../../../types';
import { IEnumService } from '../../../services/enum.service';
import { CONTRACT_TYPE } from '../../../utils';
import { IArteriaNegotiationService } from '../../../services/arteria_negotiation.service';

const name = 'negotiation-detail-modal';

@customElement({
  name,
  template,
  styles,
})
export class NegotiationDetailModal extends FASTElement {
  @INegotiationService negotiationService: INegotiationService;
  @IArteriaNegotiationService arteriaNegotiationService: IArteriaNegotiationService;
  @IEnumService enumService: IEnumService;
  @observable show: boolean = false;
  @observable width: string = '520px';
  @observable title = '';
  @observable data: IRfqInsert = {} as IRfqInsert;
  @observable selectedNegotiation = null;

  private notifier: any;
  private handler: any;
  private idHandler: any;

  connectedCallback() {
    super.connectedCallback();
    this.showModalListener();
  }

  private showModalListener() {
    const _this = this;
    this.notifier = Observable.getNotifier(this.negotiationService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        _this.show = source.negotiationDetailModalVisibility;
      },
    };
    this.idHandler = {
      handleChange(source: any, splices: Splice[]) {
        const id = source.negotiationDetailModelID;
        if (id) {
          _this.getNegotiationData(id);
        }
      },
    };
    this.notifier.subscribe(this.handler, 'negotiationDetailModalVisibility');
    this.notifier.subscribe(this.idHandler, 'negotiationDetailModelID');
  }

  private getNegotiationData(negotiationId: string) {
    this.negotiationService.getNegotiationDetails(`NEGOTIATION_ID == '${negotiationId}'`).then((data) => {
      if (data.ROW.length) {
        const negotiation = { ...data.ROW[0] };
        if (negotiation.VPPA_CONTRACT_TYPE === CONTRACT_TYPE.MINI_POST_BUILD_VPPA_AUTO_EXECUTED) {
          this.selectedNegotiation = negotiation;
          this.title = this.selectedNegotiation.VPPA_TICKER;
        } else {
          this.arteriaNegotiationService.getArteriaNegotiation(`NEGOTIATION_ID == '${negotiation.NEGOTIATION_ID}'`)
          .then((data) => {
            if(data.ROW) {
              this.selectedNegotiation = data.ROW[0];
              this.title = this.selectedNegotiation.TICKER;
            } else {
              negotiation.CONTRACT_TYPE = negotiation.VPPA_CONTRACT_TYPE;
              negotiation.NAME = negotiation.PROJECT_NAME;
              this.selectedNegotiation = negotiation;
              this.title = this.selectedNegotiation.VPPA_TICKER;
            }
          });
        }
      }
    });
  }

  public closeModal() {
    this.data = {} as IRfqInsert;
    this.negotiationService.closeNegotiationDetailModal();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.negotiationService.closeNegotiationDetailModal();
  }
}
